import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTag as ClbTag_ } from '@celebration/design-system/dist/lib/tag';
const events = {
    onClbRemove: ClbTag_.events
        .onClbRemove,
};
export const ClbTag = createComponent({
    tagName: ClbTag_.tagName,
    elementClass: ClbTag_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map